interface LegendEntry {
  label: string;
  color: string;
}

/**
 * A legend is always present for two or more series — identity never rests on
 * colour matching alone.
 */
export function Legend({ entries }: { entries: LegendEntry[] }) {
  if (entries.length < 2) return null;
  return (
    <div className="legend">
      {entries.map((entry) => (
        <span className="legend-item" key={entry.label}>
          <span className="legend-key" style={{ background: entry.color }} aria-hidden="true" />
          {entry.label}
        </span>
      ))}
    </div>
  );
}
